define('SuiteCommerce.OrderStatus.OrderFinder.ItemDetails.View',
  [
    'suitecommerce_orderstatus_itemdetails.tpl',
    'SuiteCommerce.OrderStatus.Utils',
    'Backbone',
    'underscore'
  ],
  function define(
    Template,
    Utils,
    Backbone,
    _
  ) {
    'use strict';
    return Backbone.View.extend({
      template: Template,
      initialize: function initialize(options) {
        this.item = options.item;
        this.title = this.item.status;
      },
      getContext: function getContext() {
        return {
          sections: this.getSections()
        };
      },
      getSections: function getSections() {
        if (this.item.isForShipping) {
          return this.getItemForShippingSections();
        }
        return this.getItemForPickupSections();
      },
      getItemForShippingSections: function getItemForShippingSections() {
        var trackingLines = {
          lines: []
        };
        var addressLines = {
          lines: []
        };
        var addressLinesWithoutProcess;
        var addressName;
        _.each(this.item.trackingNumbers, function includeTrackingNumberLines(tracking) {
          trackingLines.lines.push({
            value: Utils.getConfigurationParameter('orderDetailsTrackPackageLabel') + ' ' + tracking,
            link: true,
            url: 'https://www.google.com/search?q=' + tracking
          });
        });
        trackingLines.lines.push({
          value: this.item.shippingMethod,
          small: true
        });
        addressLinesWithoutProcess = this.item.shippingAddress.split('\n');
        addressName = addressLinesWithoutProcess.shift();
        addressLines.lines.push({
          value: addressName,
          strong: true
        });
        _.each(addressLinesWithoutProcess, function processAddressLine(addressLine) {
          addressLines.lines.push({
            value: addressLine
          });
        });
        return [trackingLines, addressLines];
      },
      getItemForPickupSections: function getItemForPickupSections() {
        var location = this.item.location;
        var addressWithoutProcess = location.addressLines.split('\n');
        var addressLines = {
          lines: []
        };
        var officeDataLines = {
          lines: []
        };
        addressLines.lines.push({
          value: location.name,
          strong: true
        });
        addressWithoutProcess.shift();
        _.each(addressWithoutProcess, function addAddressLine(line) {
          addressLines.lines.push({
            value: line
          });
        });
        if (location.serviceHours.length > 1) {
          for (var i = 0; i < location.serviceHours.length; i++) {
            officeDataLines.lines.push({
              value: location.openingDaysPerServiceHour[i]
            });
            officeDataLines.lines.push({
              value: location.openingHoursPerServiceHour[i]
            });
          }
        } else {
          officeDataLines.lines.push({
            value: location.openingDays
          });
          officeDataLines.lines.push({
            value: location.openingHours
          });
        }
        officeDataLines.lines.push({
          value: location.phone
        });
        return [addressLines, officeDataLines];
      }
    });
  });
